import React, { useEffect, useState } from "react";
import Logo from "../assets/logo.svg";
// import { Link } from "react-router-dom";
import { UAParser } from "ua-parser-js";
import Swal from "sweetalert2";

const Navbar = () => {
   // checking for device type
   const [deviceType, setDeviceType] = useState("");
   const [os, setOs] = useState("");
 
   useEffect(() => {
     const parser = new UAParser();
     const detectedDevice = parser.getDevice().type || "desktop"; // Default to 'desktop' if no device type is detected
     const detectedOs = parser.getOS().name;
 
     setDeviceType(detectedDevice);
     setOs(detectedOs);
   }, []);
 
   const handleGetStarted = () => {
     if (os === "Android") {
       window.location.href =
         "https://play.google.com/store/apps/details?id=com.nuprex.nuprexCustomerApplication&hl=en";
     } else if (os === "iOS") {
       window.location.href =
         "https://apps.apple.com/ng/app/nuprex-delivery-run-errands/id6738646035";
     } else {
      Swal.fire({
        title: "Device Not Supported",
        text: `The Nuprex app is optimized for mobile devices. You are using a ${deviceType}.`,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#0041a9",
      });
     }
   };
  return (
    <main>
      <div
        className="d-flex align-items-center space-around
      justify-content-between p-4 "
      >
        <a className="navbar-brand" href="/">
          <img
            src={Logo}
            width="70"
            className="d-inline-block align-top cursor-pointer"
            alt="nuprex logo"
          />
        </a>
        <div className="d-flex gap-2">
        <button
        style={{
          width: "155px",
          height: "46px",
          background: "#ff6503",
          color: "#fff",
          borderRadius: "8px",
        }}
        className="border-0 outline-0"
        onClick={handleGetStarted}
      >
        Get Started
      </button>
        </div>
      </div>
    </main>
  );
};

export default Navbar;
